import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledDialog = styled(Dialog)`
  z-index: ${({ showBlurBackground }) => showBlurBackground && 99000};
  .MuiDialog-paper {
    border-radius: 16px;
    max-width: ${({ width }) => width || '640px'};
    width: ${({ width }) => width || '640px'};
  }

  .dialog-title {
    padding: ${({ paddingTitle }) => paddingTitle || '12px 24px'};
    display: flex;
    align-items: center;
    gap: 8px;
    height: ${({ heightTitle }) => heightTitle || '56px'};
    box-sizing: border-box;
  }

  .close-icon {
    float: right;
    margin-left: auto;
    position: absolute;
    right: ${({ styleCloseIcon }) => styleCloseIcon?.right || '8px'};
    top: ${({ styleCloseIcon }) => styleCloseIcon?.top || '6px'};
    z-index: 1000;
  }

  .dialog-content {
    padding: ${({ styleContent }) => styleContent?.padding || '24px'};
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-x: ${({ styleContent }) => styleContent?.overflowX};
  }

  .dialog-actions {
    padding: 12px 24px 12px 24px;
  }
`;

export const StyledActionDialog = styled(Dialog)`
  z-index: ${({ showBlurBackground }) => showBlurBackground && 99000};
  .MuiBackdrop-root {
    backdrop-filter: ${({ showBlurBackground }) =>
      showBlurBackground && 'blur(32px)'};
    background-color: ${({ showBlurBackground }) =>
      showBlurBackground && COLOR.colorGrayV2};
  }

  .MuiPaper-root {
    @media (max-width: 600px) {
      margin: ${({ marginMobile }) => marginMobile} !important;
    }
  }
  .MuiDialogTitle-root {
    padding: 0px;
  }

  .MuiDialog-paper {
    border-radius: 16px;
    max-width: ${({ width }) => width || '640px'};
    width: ${({ width }) => width || '640px'};
  }

  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .dialog-wrapper {
    display: flex;
    gap: 16px;
    padding: 24px 40px;
    flex-direction: column;
    align-items: center;

    @media (max-width: 600px) {
      padding: ${({ paddingMobile }) => paddingMobile};
    }
  }

  .image-container {
    width: ${({ imageContainerSize }) => imageContainerSize};
    height: ${({ imageContainerSize }) => imageContainerSize};
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .icon {
    width: 100%;
  }

  .content-wrapper {
    width: ${({ widthContent }) => widthContent};
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .content-description {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: center;
  }

  .action-button {
    @media (max-width: 600px) {
      width: 100%;
    }
  }

  .dialog-action {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    padding: 0;
  }

  .dialog-action-single {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  .content-title {
    color: ${COLOR.darkGray};

    @media (max-width: 600px) {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: -0.4px;
      line-height: 24px;
    }
  }
`;
